// extracted by mini-css-extract-plugin
export default {"vip":"vip_vip__nQhss","footer":"vip_footer__SZ8hE"};